import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  const _component_PageHeader = _resolveComponent("PageHeader")
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PageHeader, { appName: 'TRUST ADMIN' }),
    _createVNode(_component_LoadingSpinner)
  ], 64))
}